import { useTranslation } from 'react-i18next'
import { type ParcelShop, useGetParcelShops } from '@dhl/mdp-api'
import { type GridColDef, Pagination } from '@dhl/components'
import { Box, Grid, Paper } from '@dhl-ui/components'

import { links } from '~/AppRoutes'
import {
  AdminDataGrid,
  lowercaseTransform,
  SearchTextField,
  useNavigateWithSearchString,
  useSearchAndPage,
} from '~/common'

export const ServicePointsPage = () => {
  const { t } = useTranslation()
  const navigateWithSearchString = useNavigateWithSearchString()

  const { searchAndPageParams, handleSearch, page, pageSize, setPage, setPageSize, search } = useSearchAndPage()
  const { data, isFetching } = useGetParcelShops(searchAndPageParams)

  const handleRowClick = (row: ParcelShop) => {
    navigateWithSearchString(links.servicePointDetailsLink(row?.parcelShopPsfKey), search)
  }

  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: t('admin.servicePointsPage.servicePointDetails.servicePoint'),
      flex: 1,
    },
    {
      field: 'parcelShopPsfKey',
      headerName: t('admin.servicePointsPage.header.servicePointId'),
      flex: 1,
    },
  ]

  return (
    <>
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Grid>
            <SearchTextField onChange={handleSearch} transform={lowercaseTransform} />
          </Grid>
        </Grid>
      </Grid>
      <Box mt={2}>
        <Paper>
          <AdminDataGrid<ParcelShop>
            loading={isFetching}
            data-testid="service-point-table"
            autoHeight
            rows={data?.content ?? []}
            columns={columns}
            onRowClick={({ row }) => handleRowClick(row)}
            rowHeight={48}
            getRowId={(row) => row.parcelShopPsfKey}
            initialState={{
              sorting: {
                sortModel: [{ field: 'name', sort: 'asc' }],
              },
            }}
            columnHeaderHeight={48}
            disableRowSelectionOnClick
            disableColumnFilter
            hideFooter
          />
        </Paper>
        <Box mt={2}>
          <Pagination
            page={page}
            count={data?.totalCount ?? 0}
            onPageChange={(_, page) => {
              setPage(page)
            }}
            rowsPerPage={pageSize}
            onRowsPerPageChange={(pageSize) => {
              setPageSize(pageSize)
            }}
          />
        </Box>
      </Box>
    </>
  )
}
